import { Injectable } from "@angular/core";
import {
    AuthProvider,
    AuthProviderPayload,
    CurrentUserResponse,
    CurrentUserUpdateRequest,
    ResetPasswordPayload,
    UserSettings,
} from "@models/*";
import { Observable } from "rxjs";
import { AbstractApiService } from "./abstract.api.service";

@Injectable()
export class AuthApiService extends AbstractApiService {
    constructor() {
        super();
    }

    //    ___       __  __
    //   / _ |__ __/ /_/ /
    //  / __ / // / __/ _ \
    // /_/ |_\_,_/\__/_//_/

    getAuthProviders(
        authProviderPayload: AuthProviderPayload,
    ): Observable<AuthProvider> {
        return this.http.post<AuthProvider>(
            `${this.baseUrl}/authentication/providers`,
            authProviderPayload,
        );
    }

    resetPassword(
        resetPasswordPayload: ResetPasswordPayload,
    ): Observable<void> {
        return this.http.post<void>(
            `${this.baseUrl}/authentication/resetPassword`,
            resetPasswordPayload,
        );
    }

    verifyEmail(): Observable<void> {
        return this.http.post<void>(
            `${this.baseUrl}/authentication/verifyEmail`,
            {},
        );
    }

    getCurrentUser(): Observable<CurrentUserResponse> {
        return this.http.get<CurrentUserResponse>(
            `${this.baseUrl}/authentication/currentUser`,
        );
    }

    saveCurrentUser(
        user: CurrentUserUpdateRequest,
    ): Observable<CurrentUserResponse> {
        return this.http.put<CurrentUserResponse>(
            `${this.baseUrl}/authentication/currentUser`,
            user,
        );
    }

    setSettings(userSettings: UserSettings): Observable<UserSettings> {
        return this.http.post<UserSettings>(
            `${this.baseUrl}/authentication/currentUser/setSettings`,
            userSettings,
        );
    }

    uploadPhoto(file: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        return this.http.post(
            `${this.baseUrl}/authentication/currentUser/photo`,
            formData,
            {
                responseType: "text",
            },
        );
    }

    deletePhoto(): Observable<void> {
        return this.http.delete<void>(
            `${this.baseUrl}/authentication/currentUser/photo`,
        );
    }

    logout(): Observable<void> {
        return this.http.post<void>(
            `${this.baseUrl}/authentication/logout`,
            {},
        );
    }
}
